import { QueryClient } from '@tanstack/react-query';
import Keycloak from 'keycloak-js';

// Read from runtime config injected by docker-entrypoint.sh
// (or public/env-config.js during local Vite dev)
const cfg = window.__APP_CONFIG__;

export const keycloak = new Keycloak({
  url: cfg.keycloakUrl,
  realm: cfg.keycloakRealm,
  clientId: cfg.keycloakClientId,
});

export const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};

export const queryClient = new QueryClient();
